<script>
import { nextTick } from 'vue';
import { generateNewDolu, updateDoluPosts, createOnePost } from '@/services/MindMovieServices';

export default {
  props: [ 'categories', 'categoriesByName'  ],
  data() {
    return {
      // user data
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),

      // form data
      revealNewForm: false,

      formType: 'youtube', // valid options: youtube, imgur, custom
      formSrc: '',
      formCustomHotlinks: [],
    };
  },
  computed: {
    formSrcCleaned() {
      let src = ''; // RETURN this string at the end

      // clean YOUTUBE id
      if (this.formType === 'youtube' && this.formSrc) {
        src = this.formSrc.trim();
        if (src.includes('/shorts/')) {
          src = src.split('/shorts/')[1].split('?')[0];
        }
        else if (src.includes('watch?v=')) {
          src = src.split('v=')[1].split('&')[0];
        }
        else if (src.includes('youtu.be/')) {
          src = src.split('.be/')[1].split('?')[0];
        }
      }

      // clean IMGUR id
      else if (this.formType === 'imgur' && this.formSrc) {
        let srcPrefix = '';
        src = this.formSrc.trim();
        if (src.includes('/a/')) {
          srcPrefix = 'a/';
          src = src.split('/a/')[1];
        }
        else if (src.includes('/gallery/')) {
          srcPrefix = 'a/';
          src = src.split('/gallery/')[1];
        }

        if (src.includes('-') && src.length > 20) {
          src = src.split('-').at(-1);
        }

        if (srcPrefix) {
          src = srcPrefix + src;
        }
      }

      // clean array of CUSTOM images
      else if (this.formType === 'custom') {
        if (this.formCustomHotlinks.length > 0) {
          src = JSON.stringify(this.formCustomHotlinks);
        }
      }



      return src;
    },
  },
  watch: {},
  methods: {
    // HELPERS
    async revealTheForm() {
      this.revealNewForm = true;
      // console.log('*** NewPost >> this.revealNewForm ***', this.revealNewForm);
    },
    async cancelAdd() {
      this.revealNewForm = false;
      await nextTick();

      this.formType = 'youtube';
      this.formSrc = '';
      this.formCustomHotlinks = [];
    },
    pushCustomHotlink() {
      if (this.formSrc.trim().length) {
        this.formCustomHotlinks.push(this.formSrc.trim());
        // console.log('*** added custom hotlink to the list ***', this.formSrc, this.formCustomHotlinks );
        this.formSrc = '';
        const fs = document.getElementById('mindmovie-custom-form-src-input');
        fs.focus();
      }
    },


    // API calls to CREATE NEW POST
    async addNewYouTubePost() {

      // API call
      const newYouTubePost = {
        type: this.formType,
        src: this.formSrcCleaned,
        likes: 0,
      };
      // console.log('*** finna send this new youtube post in an API call ***', newYouTubePost);

      // update the UI
      const newId = await createOnePost(this.uId, this.token, newYouTubePost);
      if (newId) {
        await updateDoluPosts(this.uId, this.token, generateNewDolu());
        // const updatedDoluResponseData = await updateDoluPosts(this.uId, this.token, generateNewDolu());
        // console.log('*** updateDoluPosts response ***',  updatedDoluResponseData);
        // this.$emit('new-post-was-created', newId.name, newYouTubePost);
        await this.cancelAdd();
      }
    },

    async addNewImgurPost() {

      console.clear();
      // API call
      // await nextTick();
      const newImgurPost = {
        type: this.formType,
        src: this.formSrcCleaned,
        likes: 0,
      };

      console.log('*** new Imgur Post to be added ***', newImgurPost);
      // update the UI
      const newId = await createOnePost(this.uId, this.token, newImgurPost);
      if (newId) {
        await updateDoluPosts(this.uId, this.token, generateNewDolu());
        await this.cancelAdd();
      }
    },

    async addNewCustomPost() {
      const newCustomPost = {
        type: this.formType,
        src: this.formSrcCleaned,
        likes: 0,
      };
      console.log('*** new Custom Post to be added ***', newCustomPost);

      // update the UI
      const newId = await createOnePost(this.uId, this.token, newCustomPost);
      if (newId) {
        await this.cancelAdd();
      }
    },
  },
}
</script>

<template>
  <v-dialog v-model="revealNewForm" fullscreen persistent>
    <v-card class="px-4 py-12 bg-grey-lighten-3">
      <div id="add-new-mindmovie-post-container">
        <h3 class="my-3 font-weight-bold text-capitalize">Create New {{formType}} Post</h3>
        <!-- FORM for NEW POST -->
        <div>
          <!-- post.type -->
          <v-radio-group v-model="formType" inline class="my-6 d-flex justify-space-between">
            <v-radio label="YouTube" value="youtube" class="mr-8"></v-radio>
            <v-radio label="Imgur" value="imgur" class="mr-8"></v-radio>
            <v-radio label="Custom Images" value="custom"></v-radio>
          </v-radio-group>

          <!-- post.src -->
          <v-textarea v-if="formType !== 'custom' " v-model="formSrc"
                      id="new-post-youtube-src-url"
                      variant="outlined"
                      rows="1" auto-grow
                      label="URL (click Share, then Copy Link)"
          ></v-textarea>
          <div v-else-if="formType === 'custom' ">
            <ol class="ms-4 mb-12">
              <li v-for="src of formCustomHotlinks" :key="src" class="mb-2">
                <a :href="src" target="_blank">{{src}}</a>
              </li>
            </ol>
            <div class="d-flex justify-center align-center">
              <v-textarea v-model="formSrc" id="mindmovie-custom-form-src-input"
                          variant="outlined"
                          rows="1" auto-grow
                          label="URL of image"
              ></v-textarea>
              <v-btn @click.prevent="pushCustomHotlink"
                     density="compact"
                     :color="formSrc.length ? 'blue-lighten-2' : ''"
                     :disabled="!formSrc.length"
                     class="ms-2 mb-6 text-lowercase"
              >Add Image</v-btn>
            </div>
          </div>


          <div class="d-flex justify-space-between mt-12">
            <v-btn @click.prevent="cancelAdd" color="red-lighten-2 text-capitalize">Cancel</v-btn>
            <v-btn v-if="formType === 'youtube' " @click.prevent="addNewYouTubePost" :disabled="!formSrc" color="green-lighten-1">Save Post</v-btn>
            <v-btn v-if="formType === 'imgur' " @click.prevent="addNewImgurPost" :disabled="!formSrc" color="green-lighten-1">Save Post</v-btn>
            <v-btn v-if="formType === 'custom' " @click.prevent="addNewCustomPost" :disabled="!formCustomHotlinks.length" color="green-lighten-1">Save Post</v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>

  <div v-if="!revealNewForm" class="mt-5 d-flex justify-center pl-3">
    <v-btn @click.prevent="revealTheForm" color="green-lighten-2 text-white text-capitalize" class="w-75">Create a New Post</v-btn>
  </div>
</template>

<style scoped lang="scss">
#add-new-mindmovie-post-container {
  padding-left: 16px;
  padding-right: 16px;
  @media screen and (min-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    margin: 0 auto;
    width: 600px;
    max-width: 600px;
  }
}
</style>
